// Shared WhatsApp "read state" helpers. A conversation is unread when it has an
// inbound message newer than the local "read at" timestamp we store when the
// user opens it. Used by both the inbox (green dots) and the sidebar badge so
// the two always agree.

export const READ_KEY_PREFIX = 'mm-wa-read-at:';
export const READ_CHANGE_EVENT = 'mm-wa-read-changed';

export function readReadAt(leadId) {
  try {
    return localStorage.getItem(READ_KEY_PREFIX + leadId);
  } catch {
    return null;
  }
}

export function writeReadAt(leadId, iso) {
  try {
    localStorage.setItem(READ_KEY_PREFIX + leadId, iso);
    window.dispatchEvent(new CustomEvent(READ_CHANGE_EVENT, { detail: { leadId } }));
  } catch {}
}

// True when this thread has an inbound message the user hasn't seen yet.
export function isThreadUnread(thread) {
  if (!thread || thread.last_inbound_at == null) return false;
  const readAt = readReadAt(thread.lead_id);
  return !readAt || new Date(thread.last_inbound_at) > new Date(readAt);
}

export function countUnread(threads) {
  if (!Array.isArray(threads)) return 0;
  return threads.reduce((n, t) => n + (isThreadUnread(t) ? 1 : 0), 0);
}
